export default __webpack_public_path__ + "static/media/icon-close-light.68d5abb3.svg";